<template>
    <div class="user_core">
        <Header :title="title"></Header>
        <van-row class="info_body">
            <van-col span="24" class="info_s">
                <van-form validate-first @failed="onFailed" @submit="onSubmit">
                    <van-field
                            :label="$t('withdrawal.txmoney')" colon
                            v-model="money"
                            name="money"
                            type="digit"
                            :placeholder="$t('recharge.inmoney')"
                            required
                    />
                    <div style="margin: 16px;">
                        <van-button round block type="info" color="linear-gradient(to right, #ff6034, #ee0a24)" native-type="submit">{{ $t('userinfo.tj') }}</van-button>
                    </div>
                </van-form>
                <van-row class="notes">
                    <van-col span="24">
                        <van-row>
                            <van-col span="24" class="noteTitle">
                                <van-divider
                                        :style="{ color: '#1989fa', borderColor: '#1989fa', padding: '0 16px' }"
                                >
                                    {{ $t('recharge.tips_title') }}
                                </van-divider>
                            </van-col>
                        </van-row>
                        <van-row>
                            <van-col span="24" class="content">
                               {{ $t('withdrawal.tx_info')}}
                            </van-col>
                        </van-row>
                    </van-col>
                </van-row>
            </van-col>
        </van-row>
        <Footer></Footer>
    </div>
</template>


<script>
    import Header from '@/components/Header.vue'
    import Footer from '@/components/Footer.vue'
    export default {
        name: "Withdrawal",
        data(){
            return {
                title:this.$t('withdrawal.pagetitle'),
                money:100
            }
        },
        components:{
            Header,
            Footer
        },
        methods: {
            onFailed(errorInfo) {
                console.log('failed', errorInfo);
            },
            onSubmit(values){
                console.log(values);
                this.postReq('/reqwithdrawal',values).then((res)=>{
                    if(res.code==200){
                        this.$dialog.alert({
                            message: this.$t('withdrawal.tx_ok'),
                            theme: 'round-button',
                        }).then(() => {
                            // on close
                            this.$router.push('./Me');
                        });
                    }
                });

            }
        }
    }
</script>

<style scoped lang="scss">
    .user_core{

        min-height: 700px;
        background: url("~@/assets/images/bg_header.png") no-repeat center 6%;
        background-size: 100% ;
        .info_body{
            width: 92%;
            min-height: 500px ;
            margin: 10px 15px 0 15px;
            border-radius: 10px;
            background: white;
            box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
            .info_s{
                margin: 20px auto;
                .czlx{

                }
                .notes{
                    .noteTitle{

                    }
                    .content{
                        width: 90%;
                        margin: 10px;
                        text-align: left;
                        text-indent: 10px;
                        line-height: 25px;
                    }
                }
            }
        }
    }
</style>
